<script>
/**
 * @file 我的中心
 */
import Footer from './footer.vue';
import ForkissIcon from './forkiss-icon';
import mixin from './mixins_api';

export default {
    mixins: [mixin],
    components: {
        Footer,
        ForkissIcon
    },
    created() {
        this.getGoodsDetail().then(resp => {
            this.cardList = resp.result || [];
        });
    },
    data() {
        return {
            cardList: [],
            userInfo: {}
        }
    },
    methods: {
        gotoPointsDetail() {
            this.$router.push({
                name: 'points-detail'
            });
        },
        gotoMyUserinfo() {
            this.$router.push({
                name: 'my-userinfo'
            });
        },
        gotoPlanDetail() {
            this.$router.push({
                name: 'plan-info',
                params: {
                    refer_name: 'my-center'
                }
            });
        }
    }
}
</script>

<template lang="pug">
.forkiss-my-center-container
    .center-main-container
        .center-header
            .userinfo-icon(@click="gotoMyUserinfo", data-touch="true")
            img.my-avatar(:src="userInfo.avatar_url")
        .center-info
            .my-name {{userInfo.realname}}
            //.my-points(@click="gotoPointsDetail", data-touch="true") 积分 {{userInfo.score}}
        .my-plan-box
            p.title-box
                //a.hint(@click="gotoPlanDetail")
                //    ForkissIcon(icon="forkiss-icon-question") 套餐说明
                span.title 我的套餐
            .my-card-box.mouth-box(v-for="card in cardList",
                :class="{disabled: 2 === +card.status}"
                v-if="cardList && cardList.length > 0")
                template(v-if="card.type === '2'")
                    .plan-title 时长卡
                    .hint-info(v-if="2 === +card.status") 套餐停卡中，暂不能约课
                    .hint-info(v-else) 到期时间：{{card.end_time | date("YYYY-mm-dd")}}
                    .expire-time 有效期截至{{card.last_time | date("YYYY-mm-dd")}}
                template(v-if="card.type === '1'")
                    .plan-title 次卡
                    .hint-info(v-if="2 === +card.status") 套餐停卡中，暂不能约课
                    .hint-info(v-else) 剩余次数：{{card.capacity}}次
                    .expire-time 有效期截至{{card.last_time | date("YYYY-mm-dd")}}
            .my-card-box.no-card-box(v-else)
                p 暂未开卡

    Footer(activeId="my-center")

</template>

<style lang="less" scoped>
.forkiss-my-center-container {
    position: relative;
    padding-bottom: 1rem;
    font-size: .24rem;

    .center-header {
        position: relative;
        height: 3.58rem;
        background-image: url(../assets/center-header-bg.png);
        background-size: cover;
        background-position: center;

        .my-avatar {
            position: absolute;
            width: 2rem;
            height: 2rem;
            top: 1.48rem;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 50%;
            // background-image: url(../assets/center-avatar.png);
            // background-size: contain;
        }
        .userinfo-icon {
            position: absolute;
            top: .6rem;
            right: .3rem;
            width: .48rem;
            height: .48rem;
            background-image: url(../assets/center-user.svg);
            background-size: contain;
            background-repeat: no-repeat;
        }
    }
    .center-info {
        text-align: center;

        .my-name {
            font-size: .42rem;
            color: #333;
        }
        .my-points {
            display: inline-block;
            margin-left: 0.2rem;
            color: #a4805b;

            &::after {
                content: "";
                display: inline-block;
                width: .22rem;
                height: .16rem;
                background-image: url(../assets/arrow.svg);
                transform: rotate(180deg);
                background-repeat: no-repeat;
                background-size: contain;
                background-position: center;
                margin-left: .08rem;
            }
        }
    }
    .my-plan-box {
        padding: 0 .3rem .84rem;

        .title-box {
            margin: .7rem 0 .4rem;
        }
        .title {
            color: #666;
            font-size: .32rem;
            font-weight: 600;
        }

        .hint {
            float: right;
            font-size: .24rem;
            color: #a4805b;

            .forkiss-icon-box {
                display: inline-block;
            }

            span {
                display: inline-block;
                vertical-align: middle;
            }
        }
    }

    .my-card-box {
        position: relative;
        height: 2.6rem;
        margin-bottom: .3rem;
        padding: .55rem .38rem .3rem .65rem;
        color: #e5c19b;
        border-radius: .25rem;
        background-repeat: no-repeat;
        background-size: cover;
        box-shadow: 0 .04rem .18rem 0 rgba(62, 61, 61, 0.41);

        &.disabled {
            color: #828282;
        }
        &.no-card-box {
            padding: 0 .38rem 0 .65rem;
            line-height: 2.6rem;
            color: #c6c6c6;
            font-size: .36rem;
            background-image: url(../assets/center-card3.png);
        }
        &.mouth-box {
            background-image: url(../assets/center-card1.png);
        }

        .plan-title {
            font-size: .36rem;
            font-weight: 600;
            margin-bottom: .36rem;
        }

        .expire-time {
            position: absolute;
            right: .38rem;
            bottom: .3rem;
            color: #828282;
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/components/my-center.vue